module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: _vm.klass.tag,
    attrs: {
      "invalid": _vm.invalid
    }
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n  "), (_vm.remove) ? _c('img', {
    staticClass: "hl-click",
    attrs: {
      "src": _vm.crossIcon,
      "alt": "close"
    },
    on: {
      "click": _vm.remove
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf3d33e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tag.vue
// module id = 16
// module chunks = 0